module.exports = {
          srcSet: __webpack_public_path__ + "images/1856-2b9a7d63901515fc74fb1bb4e3025f32-320.jpg"+" 320w"+","+__webpack_public_path__ + "images/1856-d9f00a300e0ed6a48bce320136875033-370.jpg"+" 370w",
          images:[ {path: __webpack_public_path__ + "images/1856-2b9a7d63901515fc74fb1bb4e3025f32-320.jpg",width: 320,height: 251},{path: __webpack_public_path__ + "images/1856-d9f00a300e0ed6a48bce320136875033-370.jpg",width: 370,height: 290}],
          src: __webpack_public_path__ + "images/1856-2b9a7d63901515fc74fb1bb4e3025f32-320.jpg",
          toString:function(){return __webpack_public_path__ + "images/1856-2b9a7d63901515fc74fb1bb4e3025f32-320.jpg"},
          
          width: 320,
          height: 251
        }